import { Injectable } from '@angular/core';
import { UserInfo } from 'src/app/models/user-info';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  userInfo: UserInfo;
}
